<template>
    <el-space>
        <el-select v-model="searchField" placeholder="请选择查询字段" class="field-select" v-if="showFields.length > 0">
            <el-option v-for="(item, index) in showFields" :key="index" :label="item.label"
                :value="item.prop"></el-option>
        </el-select>
        <div class="search-text">
            <el-input placeholder="输入关键词" clearable v-model="searchForm[searchField]" v-if="showFields.length > 0" :disabled="!searchField">
        </el-input>
        </div>
      
        <el-button type="primary" icon="el-icon-search" v-if="showFields.length > 0" @click="handlerSubmit"></el-button>
        <el-popover placement="bottom-end" :width="400" trigger="click" v-if="fields.length > 0">
            <template #reference>
                <el-button type="default" icon="el-icon-filter"></el-button>
            </template>
            <el-form :model="searchForm" ref="searchFormEl" label-width="80px">

                <el-form-item :label="item.label" :key="index" v-for="(item, index) in fields">
                    <component v-if="fieldDefs[item.prop]" :is="fieldDefs[item.prop]?.component || 'el-input'" v-model="searchForm[item.prop]" :column="item">
                    </component>
                </el-form-item>
                <el-form-item>
                    <dv class="search-action">
                        <el-button @click="handlerClearForm">清空</el-button>
                        <el-button type="primary" @click="handlerSubmit">搜索</el-button>
                    </dv>
                </el-form-item>
            </el-form>
        </el-popover>
    </el-space>
</template>

<script>
import { ref, computed } from 'vue'
import { getColumnFilter } from '../columnFilter'
export default {
    name: 'TableFilter',
    props: {
        filter: {
            type: Object
        }
    },
    setup(props, context) {
        const searchField = ref()

        const searchForm = ref({})
        const showFields = computed(() => props.filter?.fields?.filter(i => !i.filter.hide) || [])
        const fields = computed(() => props.filter?.fields || [])
        searchField.value = showFields.value[0]?.prop || ''
        const fieldDefs = {}
        fields.value.forEach(item => {
            const filterDef = getColumnFilter(item.filter?.name)
            if(filterDef){
                fieldDefs[item.prop] = filterDef
            }
        });
       
        const handlerClearForm = () => {
            searchForm.value = {}
        }
        const handlerSubmit = () => {
            context.emit('search', searchForm.value,fieldDefs)
        }
        return {
            searchField,
            searchForm,
            showFields,
            fields,
            handlerClearForm,
            handlerSubmit,
            fieldDefs
        }
    }
}
</script>

<style scoped lang="scss">
.field-select {
    width: 90px;
}
.search-text{
    width: 180px;
}
.search-action {
    text-align: right;
    width: 100%;
}
</style>